/* eslint-disable @typescript-eslint/no-unused-vars */
import { Navigate, RouteObject } from "react-router-dom";

import { GuestGuard } from "@/auth/guard/guestGuard";
import { AuthLayout } from "@/layout/Auth";
import { AuthLogin } from "@/pages/Auth/AuthLogin/AuthLogin";

export const authRoutes: RouteObject[] = [
  {
    path: "/auth",
    element: (
      <GuestGuard>
        <AuthLayout />
      </GuestGuard>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="one-id" replace />,
      },
      {
        path: "one-id",
        element: <AuthLogin />,
      },
      {
        path: "login",
        element: <Navigate to="/auth/one-id" replace />,
      },
    ],
  },
];
